import React, { Component } from "react";
import { FormGroup, Checkbox } from "react-bootstrap";
//import DamageCheckboxes from './TypeWordCheckboxItem'

export default class DamageCheckboxes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkedAll: false,
      checked: [false, false, false],
    };
    this.ordneDamaged = this.ordneDamaged.bind(this);
  }
  ordneDamaged(e) {
    this.setState({
      checkedAll: e.target.checked,
    });
  }
  changeMe(index, e) {
    var checked = this.state.checked;
    checked[index] = e.target.checked;
    this.setState({ checked: checked });
  }

  render() {
    return (
      <FormGroup>
        <Checkbox
          name={this.props.name}
          onChange={this.ordneDamaged}
          checked={this.state.checkedAll}
          value="no_damage"
          inline
        >
          No damage
        </Checkbox>{" "}
        <Checkbox
          name={this.props.name}
          disabled={this.state.checkedAll}
          onChange={this.changeMe.bind(this, 0)}
          checked={this.state.checked[0]}
          value="damagedleft"
          inline
        >
          Damage at left
        </Checkbox>{" "}
        <Checkbox
          name={this.props.name}
          disabled={this.state.checkedAll}
          onChange={this.changeMe.bind(this, 1)}
          checked={this.state.checked[1]}
          value="damageint"
          inline
        >
          Damage internal
        </Checkbox>{" "}
        <Checkbox
          name={this.props.name}
          disabled={this.state.checkedAll}
          onChange={this.changeMe.bind(this, 2)}
          checked={this.state.checked[2]}
          value="damagedright"
          inline
        >
          Damage at right
        </Checkbox>{" "}
      </FormGroup>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/wordsearchscreens/Forms/DamageCheckboxes.jsx